export default function() {
  const widgetName = 'cardWidgetMulti';
  const widgetOpts = cardWidgetMultiOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: true,
      text: 'tickets'
    },
    cardWidgetLoaded: function(data, owl, hasData) {

      const $cardWidgetItem = $('.card-widget-item');
      
      $(`#${widgetName} .buttonwrap a`).addClass('button');
      var dateText = data.items[i].Date;
        
      $('<span class="card-widget-date">' +dateText+ '</span>').prependTo(this);

      var trimmedDate = $(this).find('.card-widget-date');
      var dateMonth = trimmedDate.text().slice(0, 3);
      var dateDay = trimmedDate.text().slice(4, 7).replace(',', '');
      trimmedDate.text(dateMonth);
      trimmedDate.append('<span class="day">' +dateDay+ '</span>');
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: ['image'], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 5,
    moreButton: {
      visible: true,   
      text: 'details'
    },
    scriptPath:  widgetOpts.scriptPath,
    showDescription: true,
    slideshow: false, // for documentation on Owl Slider: https://owlcarousel2.github.io/OwlCarousel2/docs/started-welcome.html
    slideshowOptions: {
      items: 1,
      loop: true,
      margin: 10,
      navText: ['Prev','Next'],
      nav: true
    },
    textOverImage: false
  });

}